import changelog from './changelog.json'

export const APP_META = {
  productTitle: 'ИС «Учет идентификационных карт»',
  appVersion: '1.8.9',
  buildDate: '2025-07-23T11:58:01Z',
  buildVersion: '1562',
  commitId: '226ab2cc',
  changelog,
}
